import { PaginatedSocialSecurityQueryVariables } from "@/graphql/__generated__/graphql";
import ValueRangeFilter from "../../Shared/ValueRangeFilter";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedSocialSecurityQueryVariables) => void;
}

/**
 * SocialSecurityValueSearch component for filtering social security by value range
 * @param props Component properties
 * @returns JSX element
 */
function SocialSecurityValueSearch({ displayAmount, handleSubmitClick }: Props) {
  const socialSecurityValueConfig = {
    paginationStateKey: "paginatedSocialSecurity" as keyof PaginationState,
    fields: [
      {
        fieldName: "value",
        labelKey: "components:filters.socialsecurity.value",
        inputStyle: "decimal" as const,
        useBasisPoints: true,
        suffix: "%",
        decimalScale: 2,
        placeholder: "0.00"
      }
    ],
    defaultButtonTextKey: "components:filters.socialsecurity.value",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      valueRanges: Record<string, { gte: number | null; lte: number | null }>,
      sort?: any
    ): PaginatedSocialSecurityQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: filters.activeFrom || null,
        value: valueRanges.value
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      value: paginationState.filters?.value,
    })
  };

  return (
    <ValueRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={socialSecurityValueConfig}
    />
  );
}

export default SocialSecurityValueSearch;
